import { Phone, Mail, ArrowUpRight } from "lucide-react";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="relative bg-brand-footer border-t border-brand-hi pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-brand-hi">
          <div className="lg:col-span-6">
            <span className="font-heading text-3xl font-extrabold tracking-tight text-brand-text">
              G<span className="text-brand-orange">BUILDERS</span>LLC
            </span>
            <p className="mt-5 text-brand-muted max-w-sm leading-relaxed">
              Quality renovations, built to last. Commercial and residential
              craftsmanship across Florida & Virginia.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <a href="tel:7865643401" className="inline-flex items-center gap-3 text-brand-text hover:text-brand-orange transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4" strokeWidth={1.5} /> 786-564-3401
              </a>
              <a href="mailto:damianoffice01@gmail.com" className="inline-flex items-center gap-3 text-brand-text hover:text-brand-orange transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" strokeWidth={1.5} /> damianoffice01@gmail.com
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-brand-muted font-bold mb-6">Explore</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="group inline-flex items-center gap-1 text-brand-text/80 hover:text-brand-orange transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}>
                    {l.label}
                    <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-brand-muted font-bold mb-6">Get Started</p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-semibold px-6 py-3 rounded-sm transition-colors"
              data-testid="footer-cta"
            >
              Request a Free Quote
            </a>
            <p className="mt-6 text-sm text-brand-muted">Licensed & insured · FL & VA</p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-brand-muted">
          <p>© {new Date().getFullYear()} GBuildersLLC. All rights reserved.</p>
          <p>Founder & CEO — Damian Gonzalez-Perez</p>
        </div>
      </div>

      {/* Oversized brand watermark */}
      <div className="pointer-events-none select-none mt-8 -mb-6">
        <p className="font-heading text-[18vw] leading-none font-extrabold text-center text-stroke opacity-40 whitespace-nowrap">
          GBUILDERS
        </p>
      </div>
    </footer>
  );
}
